import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from "react-router-dom";

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import { getJob,applyJob } from '../../routes/UserAction';
import { domain, timeFormat } from '../../data/dummyData';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";
import Alert from '../../components/Alert/Alert';

export default function Job() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);

    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");

    const [pageData, setPageData] = useState(null);


    const fetchPage = () => {
        dispatch(getJob(id))
        .then(response => {
            setPageData(response.payload.data);
        })
        .catch(console.error);
    };

    useEffect(() => {
        fetchPage();
    }, [id]);

    // apply
    const [emailOrPhone, setEmailOrPhone] = useState('');
    const [cvFile, setCvFile] = useState(null);

    const [alert, setAlert] = useState({ show: false, message: '', type: '' });

    const handleFile = (e) => {
        // console.log("File selected:", e.target.files[0]);
        setCvFile(e.target.files[0]);
    }

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevents form from refreshing or submitting the traditional way
      
        const formData = new FormData();
        formData.append("name", emailOrPhone);
        formData.append("about", cvFile); // This must be a File object
        formData.append("job_id", pageData?.id);
      
        dispatch(applyJob(formData))
          .then((res) => {
            // alert("Application submitted!");
            setAlert({ show: true, message: "Application submitted successfully!", type: "success" });
            setEmailOrPhone('');
            setCvFile(null);

            setTimeout(() => {
                setAlert({ show: false, message: '', type: '' });
            }, 10000); // Hide after 10 seconds
          })
          .catch((err) => {
            setAlert({ show: true, message: "Failed to submit application.", type: "error" });
            console.error(err);
        });
        //   .catch(console.error);
    };

    return (
        <>
            <Header page={'job'} />

            {/* <!-- About Start --> */}
            <div className="container-fluid about pt-5" style={{zIndex: 1}}>
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                            <div className="about-content h-100">
                                <h4 className="" style={{color: 'gold'}}>{pageData?.name? pageData.name: ''}</h4>
                                {/* <h1 className="display-4 text-white mb-4">{pageData?.about? pageData.about: ''}</h1> */}
                                <hr/>
                                <p className="mb-4 text-white">{pageData?.about? pageData.about: ''}</p>
                                <hr/>
                                <div className="d-flex justify-content-start gap-4 mt-3 mb-4">
                                    {/* <span className='text-white'><i className="bi bi-heart-fill text-white" onClick={() => handleLike()}></i> {pageData?.likes? pageData.likes.length: 0} Likes</span>
                                    <span className='text-white'><i className="bi bi-eye-fill text-white"></i> {pageData?.views? pageData.views.length: 0} Views</span> */}

                                    <div className="small text-white"><span className="fa fa-calendar text-white me-2"></span> {pageData?.created_at? timeFormat(pageData?.created_at): ''}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="about-img h-100">
                                <div className="about-img-inner d-flex h-100">
                                    <img src={pageData?.image? domain+pageData.image: "./assets/img/emy.png"} className="img-fluid w-100" style={{objectFit: 'contain'}} alt={pageData?.uuid? pageData.uuid :''}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}

            
            <div className="container-fluid contact py-5">
                <div className="container py-5">
                    <div className="row g-5">

                        <div className="col-lg-6 wow mx-auto fadeInRight" data-wow-delay="0.4s">
                            <div className="form-section bg-success p-5 h-100">
                                {alert.show?
                                    <Alert
                                        type={alert.type}
                                        message={alert.message}
                                        onClose={() => setAlert({ show: false, message: '', type: '' })}
                                    />: null
                                }
                                <h1 className="display-4 text-white mb-4">Application Form</h1>
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-4">
                                        <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            id="email" 
                                            placeholder="Email/Phone"
                                            value={emailOrPhone}
                                            onChange={(e) => setEmailOrPhone(e.target.value)}
                                            required
                                            />
                                            <label htmlFor="email">Email/Phone</label>
                                        </div>
                                        </div>
                                        <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="file" 
                                            className="form-control border-0" 
                                            id="cv" 
                                            // onChange={(e) => setCvFile(e.target.files[0])}
                                            // onChange={(e) => {
                                            //     console.log("File selected:", e.target.files[0]);
                                            //     setCvFile(e.target.files[0]);
                                            // }}
                                            onChange={(e) => handleFile(e)}
                                            required
                                            />
                                            <label htmlFor="cv">CV</label>
                                        </div>
                                        </div>
                                        <div className="mx-auto col-lg-12 col-xl-6">
                                        <div className="form-section-col">
                                            <button className="btn-primary w-100 py-3 px-5" type="submit">Submit</button>
                                        </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
